import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import UpdateRepository from "../Repositories/UpdateRepository";

class UpdateBloc {
  updateChannel = new Subject();
  detailChannel = new Subject();
  documentChannel = new Subject();
  typeChannel = new Subject();
  bankChannel = new Subject();
  repository = new UpdateRepository();

  constructor() {
    this.updateChannel.next({ status: apiResponse.INITIAL });
  }

  fetchDetail = async (query) => {
    this.detailChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchDetail(query)
      .then((result) => {
        this.detailChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.detailChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchUpdate = async (query) => {
    this.updateChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchUpdate(query)
      .then((result) => {
        this.updateChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.updateChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchType = async (query) => {
    this.typeChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchType(query)
      .then((result) => {
        this.typeChannel.next({ status: apiResponse.COMPLETED, data: result });
      })
      .catch((error) => {
        this.typeChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchDocument = async (query) => {
    this.documentChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchDocument(query)
      .then((result) => {
        this.documentChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.documentChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchBank = async (query) => {
    this.bankChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchBank(query)
      .then((result) => {
        this.bankChannel.next({ status: apiResponse.COMPLETED, data: result });
      })
      .catch((error) => {
        this.bankChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };
}

export default UpdateBloc;
